import PropTypes from 'prop-types';
import ClearanceProductCards from 'containers/ProductCards/clearanceProductCards';
import breakPoints from 'helpers/Styles';
import { useState, useRef, useMemo, useEffect } from 'react';

const ClearanceProduct = ({
  data,
  features,
  buttonLabel,
  fixedPrice,
  readyToShip,
  title,
  description,
}) => {
  if (!data) return '';
  const products = data;
  const [pageCounter, setPageCounter] = useState(8);
  const loadMore = () => {
    setPageCounter(pageCounter + 8);
  };

  const ref1 = useRef(null);

  const isReadMoreInViewport = useIsInViewport(ref1, products, pageCounter);

  useEffect(() => {
    if (isReadMoreInViewport) {
      /* Delaying the loadMore function by 500ms imitating debounce. */
      setTimeout(loadMore, 400);
    }
  }, [isReadMoreInViewport]);

  if (!readyToShip && features?.length) {
    products.forEach((product) => {
      product.featureDoc = features.find(
        (feature) => feature.id === product.features.id,
      );
    });
  }

  return (
    <>
      <div className="gaming_product_list_container">
      {title ? (
        <h2 className='gaming_product_list_title'>{title}</h2>
      ) : (
        <h2 className='gaming_product_list_title'>Clearance Stock</h2>
      )}
      {products.length > 0 ?
        <div className="gaming_product_list">
          <div className="products_info">
            <div className="products">
              <ClearanceProductCards
                key={'a'}
                products={products}
                buttonLabel={buttonLabel}
                fixedPrice={fixedPrice}
                readyToShip={readyToShip}
                pageCounter={pageCounter}
              />
            </div>
            <div className="loadMore">
              <div className="paginationCounter">
                SHOWING{' '}
                {pageCounter > products.length ? products.length : pageCounter} of{' '}
                {products.length}
              </div>
              <div className="pagesLoad">
                <svg>
                  <line x1="10" y1="10" x2="192" y2="10" strokeLinecap="round" />
                  <line
                    x1="10"
                    y1="10"
                    x2="192"
                    y2="10"
                    strokeLinecap="round"
                    style={{
                      strokeDashoffset: `calc(185 - (185 * (${
                        pageCounter > products.length
                          ? products.length
                          : pageCounter
                      }  * 100 / ${products.length} })) / 100)`,
                      stroke: '#950810',
                    }}
                  />
                </svg>
              </div>
              {products.length > pageCounter ? (
                <div ref={ref1} className="loadBtn" onClick={loadMore}>
                  <button>Load More</button>
                </div>
              ) : (
                ''
              )}

              {/* <div className="wrapper">
                <div className="header">
                  <div>
                    <h1 className="heading">{title || ''}</h1>
                  </div>
                  <div className="description">{description.length > 0 && description[0]?.text}</div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        :  <p className="text-center"> No Product Found</p>
        }
        <style jsx>
          {`
            .loadBtn {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              padding: 8px 24px;
              gap: 10px;
              width: 192px;
              height: 40px;
              background: #242424;
              border-radius: 4px;
              flex: none;
              order: 1;
              flex-grow: 0;
              margin: auto;
              margin-bottom: 34px;
            }
            .loadBtn button {
              background: transparent;
              border: none;
              color: #e4e4e4;
              font-family: 'Roboto-Medium';
              font-weight: 600;
              font-size: 13px;
              line-height: 24px;
              text-align: center;
            }
            .loadMore {
              text-align: center;
            }
            .pagesLoad svg {
              height: 40px;
            }
            .pagesLoad svg line:nth-child(2) {
              stroke: #950810;
            }
            .loadMore .pagesLoad svg line {
              stroke: #949494;
              stroke-width: 5px;
              stroke-dasharray: 185;
            }
            .loadMore .pagesLoad svg {
              width: 200px;
            }
            .paginationCounter {
              padding: 15px;
              color: #949494;
            }
            .gaming_product_list_container {
              padding: 0 0 60px;
              background-color: #000000;
            }
            .gaming_product_list_title {
              text-align: center;
              font-family: "Roboto-Medium";
              font-size: 40px;
              margin: 50px 0 40px;
            }
            .gaming_product_list {
              display: flex;
            }
            .products_info {
              display: flex;
              flex-direction: column;
              gap: 32px;
            }
            .info {
              display: flex;
              gap: 32px;
            }
            .info_data {
              flex: 1;
              display: flex;
              flex-direction: column;
            }
            .info_header {
              color: #e4e4e4;
              font-family: 'big_noodle_titling';
              font-size: 31px;
              letter-spacing: 0;
              line-height: 40px;
            }
            .info_keywords {
              color: #949494;
              font-family: 'big_noodle_titling';
              font-size: 20px;
              letter-spacing: 0;
              line-height: 24px;
            }
            .info_description {
              flex: 2;
              color: #e4e4e4;
              font-family: 'Roboto-Light';
              font-size: 16px;
              letter-spacing: 0;
              line-height: 24px;
            }
            .products {
              display: flex;
              padding: 20px 0px;
            }
            @media (max-width: ${breakPoints.medium}) {
              .gaming_product_list_container {
                padding-top: 10px;
                padding-bottom: 30px;
              }
              .gaming_product_list {
                //flex-wrap: wrap;
                display: block;
              }
              .gaming_product_list_title {
                font-size: 30px;
              }
              .products_info {
                //flex-wrap: wrap;
                //width: 90px;
              }
              .info {
                display: block;
                //width: 90%;
              }
              .info_data {
                max-width: 100%;
              }
              .info_description {
                padding-top: 10px;
                width: 100%;
              }
              .gaming_product_list {
                flex-wrap: wrap;
              }
              .products {
                display: block;
              }
            }
            .header {
              padding: 50px 100px;
            }
            .heading {
              color: #e4e4e4;
              font-family: 'big_noodle_titling';
              font-size: 39px;
              letter-spacing: 0;
              line-height: 48px;
              text-align: center;
            }
            .description {
              width: 656px;
              margin-left: auto;
              margin-right: auto;
              color: #e4e4e4;
              font-family: 'Roboto-Light';
              font-size: 16px;
              letter-spacing: 0;
              line-height: 24px;
              text-align: center;
            }
            @media (max-width: ${breakPoints.small}) {
              .description {
                margin-left: auto;
                margin-right: auto;
                color: #e4e4e4;
                font-family: 'Roboto-Light';
                font-size: 16px;
                letter-spacing: 0;
                line-height: 24px;
                text-align: center;
              }
            }
            @media (max-width: ${breakPoints.medium}) {
              .description {
                width: unset;
              }
            }
            @media (max-width: ${breakPoints.small}) {
              .header {
                background-color: #040404;
                padding: 50px 50px;
              }
            }
            .text-center {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          `}
        </style>
      </div>
    </>
  );
};

ClearanceProduct.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  features: PropTypes.arrayOf(PropTypes.object),
  buttonLabel: PropTypes.string,
  fixedPrice: PropTypes.bool,
  readyToShip: PropTypes.bool,
};

ClearanceProduct.defaultProps = {
  features: null,
  buttonLabel: null,
  fixedPrice: false,
  readyToShip: false,
};

/* A custom hook that is used to check if the element is in the viewport. */
function useIsInViewport(ref, products, pageCounter) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) =>
        setIsIntersecting(entry.isIntersecting),
      ),
    [],
  );

  useEffect(() => {
    products.length > pageCounter ? observer.observe(ref.current) : false;

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
}

export default ClearanceProduct;